import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const chat = createAsyncThunk("chat/chat", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "chat/chat/" + action.receiver_id+"/" + action.annee+"/"+action.client, {
    method: 'Get',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const chat = await response.json();
  return chat;
});

export const users = createAsyncThunk("chat/users", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "chat/users", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const chat = await response.json();
  return chat;
});
export const messages = createAsyncThunk("chat/messages", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "chat/messages", {
    method: 'Post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });

  const chat = await response.json();
  return chat;
});

const messagerieReduce = createSlice({
  name: "messagerie",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    // messagerieDeleted(state, action) {
    //   const { id } = action.payload;
    //   fetch(Configuration.BACK_BASEURL + "chat/deleteMessagerie/"+id, {
    //     method: 'DELETE',
    //     headers: {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json'
    //     },
    //   });
    // },

  },
  extraReducers: (builder) => {

  },

});


export default messagerieReduce.reducer;
